import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
    html {
        width: 100vw;
        height: 100vh;
        overflow-x: hidden;
        font-size: 16px;
        -webkit-font-smoothing: antialiased;
    }

    html::-webkit-scrollbar {
        width: 6px;
    }

    html::-webkit-scrollbar-thumb {
        background: #cccccc;
        border-radius: 3px;
    }

    html::-webkit-scrollbar-track {
        border-radius: 3px;
    }

    body {
        margin: 0;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
        'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
        sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    
    code {
        font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
        monospace;
    }
`;